//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "NotificationUsedCookies",

  data: function () {
    return {
      isShow: false
    }
  },

  mounted: function () {
    // setTimeout(async () => {
    //   await this.checkUsedCookies();
    // }, (10 * 1000))
  },

  methods: {
    checkUsedCookies: async function () {
      const notificationUsedCookies = await this.$cookies.get('notification-used-cookies');
      if (String(notificationUsedCookies) === "1") {
        return
      }

      this.isShow = true;
    },
    confirmUsedCookies: async function () {
      await this.$cookies.set('notification-used-cookies', '1');
      this.isShow = false;
    },
  }
}
